import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SButton from "components/Common/Button"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import DimensionAction from "store/dimension-resource/actions"
import Skeleton from "react-loading-skeleton"
import TableContainer from "components/newTables/TableContainer"

export default function MasterDimension() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [pagination, setPagination] = React.useState({
    page: 0,
    size: 10,
  })
  const [params, setParams] = useState({
    page: 0,
    size: 10,
  })
  const [filter, setFilter] = useState({ categoryName: "", item: "" })

  const columns = React.useMemo(
    () => [
      {
        Header: "商品カテゴリ",
        accessor: "categoryName",
        defaultCanSort: false,
      },

      {
        Header: "寸法項目",
        accessor: "item",
        defaultCanSort: false,
      },
      {
        Header: "枠種類",
        accessor: "frameType",
        defaultCanSort: false,
      },
      {
        Header: "形式",
        accessor: "format",
        defaultCanSort: false,
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(`/master/dimension/${cell.row.original.id}`)
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  React.useEffect(() => {
    dispatch(DimensionAction.getListPage({ ...params, ...pagination }))
  }, [params, pagination])

  const onChangeFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    setParams({
      ...filter,
      page: 0,
      size: 10,
    })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"寸法マスター"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={3}>
                <TextInputWithLabel
                  label={"商品カテゴリ"}
                  placeholder={""}
                  value={filter.categoryName}
                  type="text"
                  name="categoryName"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={3}>
                <TextInputWithLabel
                  label={"項目"}
                  placeholder={""}
                  value={filter.item}
                  type="text"
                  name="item"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={3} className="d-flex align-content-end flex-wrap">
                <SButton
                  className={"mx-2 button"}
                  onClick={() => {
                    onSearch()
                  }}
                >
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <Row className="mb-3">
              <Col sm="6" />
              <Col
                sm="6"
                className="d-flex align-items-end justify-content-end"
              >
                <SButton
                  className={"mx-2 button"}
                  onClick={() => history.push("/master/dimension/add")}
                >
                  新規追加
                </SButton>
              </Col>
            </Row>
            {store.dimension.pageData.loading ? (
              <Skeleton count={5} />
            ) : store.dimension.pageData.data?.content?.length === 0 ? (
              <h3 className="text-center">No Data to Display</h3>
            ) : (
              <TableContainer
                data={store.dimension.pageData.data?.content}
                columns={columns}
                pagination
                page={pagination.page}
                size={pagination.size}
                count={store.dimension.pageData.data?.totalPages || 1}
                params={pagination}
                setParams={setPagination}
              />
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
